import { OverlayState } from '@/hooks/useOverlay'
import { RowValueFlag, DocumentFlag } from '@/types/flags'
import { Popover, PopoverProps } from '@mui/material'
import FlagList from './FlagList'

type FlagsDialogProps = {
  overlay: OverlayState
  documentFlags: DocumentFlag[]
  rowValueFlags: RowValueFlag[]
  isLoading?: boolean
  onRowValueFlagClick?: (
    flag: RowValueFlag,
    cellToFocus: HTMLInputElement | HTMLDivElement | null,
  ) => void
} & Omit<PopoverProps, 'open'>

export default function FlagsPopover({
  overlay,
  documentFlags = [],
  rowValueFlags = [],
  isLoading = false,
  onRowValueFlagClick,
  ...rest
}: FlagsDialogProps) {
  return (
    <Popover
      open={overlay.isOpen}
      anchorEl={overlay.anchorEl as Element}
      onClose={overlay.close}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      disableScrollLock
      disableEnforceFocus
      disableRestoreFocus
      {...rest}
    >
      <FlagList
        documentFlags={documentFlags}
        rowValueFlags={rowValueFlags}
        isLoading={isLoading}
        onRowValueFlagClick={onRowValueFlagClick}
        sx={{ py: 2, maxWidth: 400, minWidth: 200 }}
      />
    </Popover>
  )
}
